/**
 * Pazaak Cards enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file PazaakCards.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export enum PazaakCards {
  INVALID = -1,
  PLUS_1 = 0,
  PLUS_2 = 1,
  PLUS_3 = 2,
  PLUS_4 = 3,
  PLUS_5 = 4,
  PLUS_6 = 5,
  MINUS_1 = 6,
  MINUS_2 = 7,
  MINUS_3 = 8,
  MINUS_4 = 9,
  MINUS_5 = 10,
  MINUS_6 = 11,
  PLUS_MINUS_1 = 12,
  PLUS_MINUS_2 = 13,
  PLUS_MINUS_3 = 14,
  PLUS_MINUS_4 = 15,
  PLUS_MINUS_5 = 16,
  PLUS_MINUS_6 = 17,
  UNUSED_CARD = 18, //appears to be unused
  MAX_CARDS = 18,
  MAIN_CARD_1 = 101,
  MAIN_CARD_2 = 102,
  MAIN_CARD_3 = 103,
  MAIN_CARD_4 = 104,
  MAIN_CARD_5 = 105,
  MAIN_CARD_6 = 106,
  MAIN_CARD_7 = 107,
  MAIN_CARD_8 = 108,
  MAIN_CARD_9 = 109,
  MAIN_CARD_10 = 110
};
  
  
